export class LoadClientRuleFields{
    id:number;
    field:string;
    ruleId:number;
    active:boolean;
    constructor (){}
}